import { Building2, type LucideIcon, ShieldCheck, UserRound } from "lucide-react";

/** The account area (/account): its sections, also listed in the sidebar's account menu. */
export const ACCOUNT_SECTIONS: Array<{ to: string; label: string; text: string; icon: LucideIcon }> = [
  { to: "/account/details", label: "Personal details", text: "Name and email", icon: UserRound },
  { to: "/account/security", label: "Security", text: "Sign-in, PIN and session", icon: ShieldCheck },
  { to: "/account/profiles", label: "Profiles", text: "Businesses you belong to", icon: Building2 },
];
